/**
 * @generated SignedSource<<ef63d68ebd28e344df3d05d88a4dd641>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "details",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Endpoint",
        "kind": "LinkedField",
        "name": "endpoints",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameUk",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceMaster_washPagesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceMaster_washPagesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a79e410fd6793f983e521318096bff22",
    "id": null,
    "metadata": {},
    "name": "serviceMaster_washPagesQuery",
    "operationKind": "query",
    "text": "query serviceMaster_washPagesQuery(\n  $id: String\n) {\n  serviceById(id: $id) {\n    id\n    name\n    details\n    endpoints {\n      id\n      name\n      nameUk\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ecfc7b2c3d9be8ea1d9bbbfb7a446b5a";

module.exports = node;
